import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { stringify as stringifyQuery } from 'hub-http/helpers/params';
import { jsx as _jsx } from "react/jsx-runtime";
const ReturnLink = ({
  query
}) => /*#__PURE__*/_jsx(Link, {
  to: Object.assign({
    pathname: '/'
  }, query ? {
    search: stringifyQuery(query)
  } : {}),
  children: "hubspot.com/login"
});
ReturnLink.propTypes = {
  query: PropTypes.object
};
export default ReturnLink;